<h2> {{'menu_nav_admin_settings_text' | i18n}}</h2>
<admin-edit-setting [settings]="settings"></admin-edit-setting>
<admin-edit-setting [settings]="navigation"></admin-edit-setting>